import React from "react";
import ContentLoader from "react-content-loader";

const MyLoader = ({
  rows = 10,
  columns = [
    { width: 190, label: "Client" },
    { width: 95, label: "Start Dtae" },
    { width: 130, label: "Total Time Spent" },
    { width: 150, label: "last Meeting" },
    { width: 140, label: "Coach Notes" },
    { width: 90, label: "Status" },
    { width: 110, label: "Last Activity" },
    { width: 180, label: "Last Step Completed" },
    { width: 570, label: "Ready For Review" },
    { width: 570, label: "Client Requested Access To" },
    { width: 570, label: "Steps In Progress" },
  ],
  rowHeight = 57,
  headerHeight = 56.8,
  rowGap = 8,
  columnGap = 11,
  headerGap = 16,
  startX = 7,
  startY = 7,
  ...props
}) => {
  const renderHeaders = () => {
    let xPosition = startX;
    return columns.map((col, index) => {
      const headerRect = (
        <rect
          key={`header-${index}`}
          x={xPosition}
          y={startY}
          rx="8"
          ry="8"
          width={col.width}
          height={headerHeight}
        />
      );
      xPosition += col.width + columnGap;
      return headerRect;
    });
  };

  const renderRows = () => {
    const rowElements = [];
    for (let row = 0; row < rows; row++) {
      let xPosition = startX;
      columns.forEach((col, index) => {
        rowElements.push(
          <rect
            key={`row-${row}-${index}`}
            x={xPosition}
            y={
              startY +
              headerHeight +
              headerGap +
              row * (rowHeight + rowGap)
            }
            rx="8"
            ry="8"
            width={col.width}
            height={rowHeight}
          />
        );
        xPosition += col.width + columnGap;
      });
    }
    return rowElements;
  };

  const totalHeight =
    startY + headerHeight + headerGap + rows * (rowHeight + rowGap);

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={totalHeight}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      {renderHeaders()}
      {renderRows()}
    </ContentLoader>
  );
};

export default MyLoader;


